import axios from 'axios';
let qs = require('qs');

axios.defaults.withCredentials = true;

// let host = window.location.host
let host = 'www.ringdata.com';
// let host = 'www.ringdata.com'
let baseUrl = `https://${host}/cloudexperiment`;
let baseAuthUrl = `https://i.ringdata.com/uums`;

/**
 * get 请求
 */
const httpGet = function (url = '', data = {}) {
  const instance = axios.create({
    baseURL: baseUrl,
    withCredentials: false,
    headers: {
      'Accept': 'application/json;charset=UTF-8',
      'content-type': 'application/json',
      'Authorization': this.$cookies.get("tokenWeb") ? this.$cookies.get("tokenWeb") : "",
      'tokenWeb': this.$cookies.get("tokenWeb") ? this.$cookies.get("tokenWeb") : ""
    }
  });
  return instance.get(url, {
    params: data
  }).then((result) => {
    var res = result.data;
    if(res && res.code === 0) {
      return Promise.resolve(res);
    } else {
      if (res.code === 15000){
        this.$message({
          message: '系统异常',
          type: 'warning'
        });
        return res;
      }
      return Promise.resolve(res);
    }
  }).catch((error) => {
    let res = error.response
    if (res.status === 400 || res.status === 401) {
      if (res.data) {
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
        this.$cookies.remove("tokenWeb");
        this.$cookies.remove("userInfo");
        this.$cookies.remove("tokenWebRefresh");
        //先清除，防止账号切换时，isRequestor未更新
        this.$cookies.remove("isRequestor");
      } else {
        this.$message({
          message: '登录信息已失效,请重新登录',
          type: 'warning'
        });
      }
      this.$router.push('/login');
      return res;
    }
    res = {
      code: -1,
      message: '网络请求异常，请稍后再试或联系客服！'
    }
    console.log('网络请求错误');
    return res;
  })
}


/**
 * post 请求
 */
const httpPost = function (url = '', data = {}) {
  let tempUrl = url.indexOf("centerAuth") != -1 ? baseAuthUrl : baseUrl;
  const instance = axios.create({
    baseURL: tempUrl,
    withCredentials: false,
    headers: {
      'Accept': 'application/json;charset=UTF-8',
      'content-type': 'application/json',
      'Authorization': this.$cookies.get("tokenWeb") ? this.$cookies.get("tokenWeb") : "",
      'tokenWeb': this.$cookies.get("tokenWeb") ? this.$cookies.get("tokenWeb") : ""
    }
  });
  return instance.post(url, JSON.stringify(data)).then((result) => {
    var res = result.data;
    if(res && res.code === 0) {
      return Promise.resolve(res);
    } else {
      if (res.code === 15000){
        this.$message({
          message: '网络请求异常，请稍后再试或联系客服！',
          type: 'warning'
        });
        return res;
      } else if (res.code === 10001 || res.code == 10002 || res.code == 10003) {
        this.$message({
          message: res.message,
          type: 'warning'
        });
        this.$cookies.remove("tokenWeb");
        this.$cookies.remove("userInfo");
        this.$cookies.remove("tokenWebRefresh");
        //先清除，防止账号切换时，isRequestor未更新
        this.$cookies.remove("isRequestor");
        this.$cookies.remove("tokenWeb", "/", "ringdata.com");
        this.$cookies.remove("userInfo", "/", "ringdata.com");
        this.$cookies.remove("tokenWebRefresh", "/", "ringdata.com");
        this.$router.push('/login');
        return res;
      }
      return Promise.resolve(res);
    }
  }).catch((error) => {
    let res = error.response
    if (res.status === 400 || res.status === 401) {
      if (res.data) {
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
        this.$cookies.remove("tokenWeb");
        this.$cookies.remove("userInfo");
        this.$cookies.remove("tokenWebRefresh");
        //先清除，防止账号切换时，isRequestor未更新
        this.$cookies.remove("isRequestor");
        this.$cookies.remove("tokenWeb", "/", "ringdata.com");
        this.$cookies.remove("userInfo", "/", "ringdata.com");
        this.$cookies.remove("tokenWebRefresh", "/", "ringdata.com");
      } else {
        this.$message({
          message: '登录信息已失效,请重新登录',
          type: 'warning'
        });
      }
      this.$router.push('/login');
      return res;
    } else {
      this.$cookies.remove("tokenWeb");
      this.$cookies.remove("userInfo");
      this.$cookies.remove("tokenWebRefresh");
      //先清除，防止账号切换时，isRequestor未更新
      this.$cookies.remove("isRequestor");
      this.$cookies.remove("tokenWeb", "/", "ringdata.com");
      this.$cookies.remove("userInfo", "/", "ringdata.com");
      this.$cookies.remove("tokenWebRefresh", "/", "ringdata.com");
      this.$router.push('/login');
      return res;
    }
    res = {
      code: -1,
      message: '网络请求异常，请稍后再试或联系客服！'
    }
    console.log('网络请求错误');
    return res;
  })
}

/**
 * post 请求
 */
const httpPostForIos = function (url = '', data = {}) {
  let tempUrl = url.indexOf("centerAuth") != -1 ? baseAuthUrl : baseUrl;
  const instance = axios.create({
    baseURL: tempUrl,
    withCredentials: false,
    headers: {
      'Accept': 'application/json;charset=UTF-8',
      'content-type': 'application/json',
      'Authorization': this.$cookies.get("tokenWeb") ? this.$cookies.get("tokenWeb") : ""
    }
  });
  return instance.post(url, JSON.stringify(data)).then((result) => {
    var res = result.data;
    if(res && res.code === 0) {
      return Promise.resolve(res);
    } else {
      if (res.code === 15000){
        this.$message({
          message: '网络请求异常，请稍后再试或联系客服！',
          type: 'warning'
        });
        return res;
      } else if (res.code === 10001 || res.code == 10002 || res.code == 10003) {
        this.$message({
          message: '登录失效',
          type: 'warning'
        });
        this.$cookies.remove("tokenWeb");
        this.$cookies.remove("userInfo");
        this.$cookies.remove("tokenWeb", "/", "ringdata.com");
        this.$cookies.remove("userInfo", "/", "ringdata.com");
        this.$router.push('/login');
        return res;
      }
      return Promise.resolve(res);
    }
  }).catch((error) => {
    let res = error.response
    if (res.status === 400 || res.status === 401) {
      if (res.data) {
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
        this.$cookies.remove("tokenWeb");
        this.$cookies.remove("userInfo");
        this.$cookies.remove("tokenWeb", "/", "ringdata.com");
        this.$cookies.remove("userInfo", "/", "ringdata.com");
      } else {
        this.$message({
          message: '登陆信息已失效,请重新登陆',
          type: 'warning'
        });
      }
      this.$router.push('/login');
      return res;
    } else {
      this.$cookies.remove("tokenWeb");
      this.$cookies.remove("userInfo");
      this.$cookies.remove("tokenWeb", "/", "ringdata.com");
      this.$cookies.remove("userInfo", "/", "ringdata.com");
      this.$router.push('/login');
      return res;
    }
    res = {
      code: -1,
      message: '网络请求异常，请稍后再试或联系客服！'
    }
    console.log('网络请求错误');
    return res;
  })
}


/**
 * post 请求
 */
const httpPostIsAnonymous = function (url = '', data = {}) {
  const instance = axios.create({
    baseURL: baseAuthUrl,
    withCredentials: false,
    headers: {
      'Accept': 'application/json;charset=UTF-8',
      'content-type': 'application/json'
    }
  });
  return instance.post(url, JSON.stringify(data)).then((result) => {
    var res = result.data;
    if(res && res.code === 0) {
      return Promise.resolve(res);
    } else {
      if (res.code === 15000){
        this.$message({
          message: '网络请求异常，请稍后再试或联系客服！',
          type: 'warning'
        });
        return res;
      }
      return Promise.resolve(res);
    }
  }).catch(() => {
    let res = {
      code: -1,
      message: '网络请求异常，请稍后再试或联系客服！'
    }
    console.log('网络请求错误');
    return res;
  })
}

/**
 * 认证请求
 */
const httpPostToken = function (url = '', data) {
  const instance = axios.create({
    baseURL: baseAuthUrl,
    withCredentials: false,
    headers: {
      'Authorization': 'Basic bW9uZXR3YXJlOm1vbmV0d2FyZTIwMTkuQHNoLmNvbQ==',
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
  });
  return instance.post(url, data).then((result) => {
    var res = result.data;
    if(result && result.status === 200) {
      if (res != null && res.access_token != null && res.access_token != '') {
        // this.$cookies.set("tokenWeb", res.access_token, 24 * 60 * 60);
        // this.$cookies.set("tokenWebRefresh", res.refresh_token, 25 * 60 * 60);
        // this.$cookies.set("userInfo", JSON.stringify(res.userInfo), 24 * 60 * 60);
        this.$cookies.set("tokenWeb", res.access_token, 24 * 60 * 60, '/', 'ringdata.com', false);
        this.$cookies.set("tokenWebRefresh", res.refresh_token, 25 * 60 * 60, '/', 'ringdata.com', false);
        this.$cookies.set("userInfo", JSON.stringify(res.userInfo), 24 * 60 * 60, '/', 'ringdata.com', false);
        res = {
          code: 0,
          message: '登录成功'
        }
        return Promise.resolve(res);
      } else {
        res = {
          code: -1,
          message: '登录失败，请稍后再试或联系客服！'
        }
        return res;
      }
    }
  }).catch((error) => {
    let res = error.response
    if (res.status === 400 || res.status === 401 || res.status === 500) {
      res = {
        code: res.data.code,
        message: res.data.message
      }
      return res;
    }
    res = {
      code: -1,
      message: '网络请求异常，请稍后再试或联系客服！'
    }
    console.log('网络请求错误');
    return res;
  })
}

export {
  baseUrl,
  baseAuthUrl,
  // baseSocketUrl,
  httpGet,
  httpPost,
  httpPostIsAnonymous,
  httpPostToken,
  httpPostForIos
}



// WEBPACK FOOTER //
// ./src/utils/httpService.js